export enum Actions {
  'ChangeSearchTerm',
}
